import { Component, OnInit,ViewChild } from '@angular/core';
import { ViewWillEnter ,IonContent} from '@ionic/angular';
import { Router } from '@angular/router';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { CustomerListService } from '../../services/customer-list.service';


@Component({
  selector: 'app-customer-lookup-page',
  templateUrl: 'customer-lookup.page.html',
  styleUrls: [
    './customer-lookup.page.scss',
    '../../styles/customer-lookup.styles.scss'
  ]
})
export class CustomerLookupPage implements OnInit, ViewWillEnter {
@ViewChild(IonContent) content!: IonContent;
  customerCode: string;
  customerName: string;

  public rows: any;

  requestParams: any;

  currPage: number;
  pageSize: number;

  submitting: boolean;

  totalElements: number = 0;
  totalPages: number = 0;
  loaded:boolean;
  currentRoute: string;

  constructor(
    private router: Router,
    private authService: GtrakAuthService,
    private customerListService: CustomerListService,
  ) { 
    this.currentRoute = null;
  }

  ngOnInit(): void {
   this.loaded=false;
    this.requestParams = new RequestParams();

    if(!this.authService.user.canViewCustomerLookup) {
      this.router.navigate([this.authService.user.homeLocation]);
    }

    this.rows = [];
    this.currentRoute = this.router.url;

    this.currPage = 1;
     if( localStorage.getItem("pageSize")!=null){
        this.pageSize=Number(localStorage.getItem("pageSize"));
        }
        else{
        this.pageSize = 500;
        }

    this.requestParams.setOrdering('Name', 'asc');

    this.getCustomerList();
    //this.loaded=true;
  }

  ionViewWillEnter(): void {
      if( localStorage.getItem("pageSize")!=null){
        this.pageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.pageSize = 500;
   }
    this.requestParams.setPaging(this.currPage, this.pageSize);
    this.rows = [...this.rows]; 
  }


  async getCustomerList() {
    this.loaded=false;
    this.submitting = true;
    this.requestParams.setPaging(this.currPage, this.pageSize);
    var customers = await this.customerListService.query(this.requestParams);
    
    this.totalElements = customers.totalRecords;
    this.totalPages = customers.totalPages;

    this.rows = customers.results;
    this.submitting = false;
    this.loaded=true;
  }

  async getCustomerListByCode() { 
    this.loaded=false;
    this.customerCode = this.customerCode ?? '';

    //empty string identifier
    if(this.customerCode === ''){
      delete this.requestParams.filters.Name;
      delete this.requestParams.filters.CustomerCode;
      this.getCustomerList();
      return;
    }

    //delete old filters
    if(this.requestParams.filters.Name?.trim()!== '')
      delete this.requestParams.filters.Name;
    if(this.requestParams.filters.CustomerCode?.trim() !== '')
      delete this.requestParams.filters.CustomerCode;

    this.currPage = 1;
    if(this.customerName!=""){
      this.requestParams.filters.Name = this.customerName;
    }
    this.requestParams.filters.CustomerCode = this.customerCode;

    this.requestParams.setOrdering('CustomerCode', 'asc');

    await this.getCustomerList();
    this.loaded=true;
  }

  async getCustomerListByName() {
    this.loaded=false;
    this.customerName = this.customerName ?? '';

    //empty string identifier
    if(this.customerName === ''){
      delete this.requestParams.filters.Name;
      delete this.requestParams.filters.CustomerCode;
      this.getCustomerList();
      return;
    }
    
    //delete old filters
    if(this.requestParams.filters.Name?.trim() !== '')
      delete this.requestParams.filters.Name;
    if(this.requestParams.filters.CustomerCode?.trim() !== '')
      delete this.requestParams.filters.CustomerCode;

    this.currPage = 1;
   if(this.customerCode!="" && this.customerCode!=undefined){
      this.requestParams.filters.CustomerCode = this.customerCode;
    }
    this.requestParams.filters.Name = this.customerName;

    this.requestParams.setOrdering('Name', 'asc');

    await this.getCustomerList();
    //this.loaded=true;
  }
async setPage(event: { pageNumber: number, pageSize:number ;sortField?: string, sortDirection?: string }): Promise<void> {
        this.loaded = false;
        this.pageSize=event.pageSize;
        this.currPage = event.pageNumber;
        if(event.sortField==""){
             this.requestParams.setOrdering("Name", "asc");
        }else{
        this.requestParams.setOrdering(event.sortField, event.sortDirection);
        }
        await this.getCustomerList();
         this.content.scrollToTop(500);
        this.loaded = true;
        }

  onEnterKeyCustCode(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.getCustomerListByCode();
    }
    onEnterKeyCustName(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.getCustomerListByName();
    }
}